export default __webpack_public_path__ + "static/media/uefa-icon.cea6f9ec.webp";